import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'

interface RightMostPaneStyle {
    showRightMostPane: boolean
    currentPane: string
}

const useRightMostPaneStyles = makeStyles((theme: Theme) => ({
    tabLabel: {
        fontSize: pxToRem(13),
        textTransform: 'uppercase',
        width: pxToRem(75),
        textAlign: 'justify',
        lineHeight: pxToRem(15),
    },
    defaultTextColor: {
        color: '#A78966',
    },
    selectedTabText: {
        color: '#04325B',
    },
    selectedTab: {
        borderBottom: '3px solid #304959',
    },
    tabRoot: {
        minWidth: pxToRem(125),
        maxWidth: pxToRem(125),
    },
    fullWidthRightPaneKeynotesContainer: {
        borderRight: 'none',
        width: (props: RightMostPaneStyle) =>
            props.showRightMostPane ? pxToRem(433) : pxToRem(51),
        minWidth: (props: RightMostPaneStyle) =>
            props.showRightMostPane ? pxToRem(433) : pxToRem(51),
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: '#EDF0F6',
        willChange: 'width',
        transition: 'width 458ms ease-in-out',
    },
    askDelaWidth: {
        width: `${pxToRem(433)} !important`,
    },
    buttonContainer: {
        width: pxToRem(51),
        minWidth: pxToRem(51),
        background: '#EDF0F6',
        paddingTop: pxToRem(50),
        borderInline: '1px solid #DDDDDD',
        height: '100%',
        flexShrink: 0,
    },
    rightPaneButton: {
        margin: pxToRem(3),
        marginBottom: pxToRem(10),
        width: pxToRem(26),
        height: pxToRem(25.14),
        borderRadius: pxToRem(4),
        color: '#ffffff',
        '&:hover': {
            background: '#D5F3FF',
        },
        marginLeft: pxToRem(8),
    },
    rightPaneIconActive: {
        fill: '#ffffff',
        color: '#ffffff',
        '&:hover': {
            fill: '#314959',
            color: '#314959',
        },
    },
    active: {
        background: '#314959',
        '& > svg': {
            fill: '#ffffff',
            color: '#ffffff',
            '&:hover': {
                fill: '#314959',
                color: '#314959',
            },
        },
    },
    activeClashIcon: {
        background: '#314959',
        '& > svg': {
            fill: '#ffffff',
            color: '#ffffff',
            '&:hover': {
                fill: '#314959',
                color: '#314959',
            },
        },
    },
    rightPaneIcon: {
        fill: '#314959',
        color: '#314959',
        '&:hover': {
            fill: '#314959',
            color: '#314959',
        },
    },
    specIntIcon: {
        fill: '#8A30BE',
        color: '#8A30BE',
        '&:hover': {
            fill: '#8A30BE',
            color: '#8A30BE',
        },
    },
    rightPaneClashIcon: {
        height: 18.02,
        width: 20.74,
    },
    clashIconBadge: {
        fontSize: pxToRem(10),

        '& .MuiBadge-anchorOriginTopRightRectangle': {
            top: pxToRem(-4),
            borderRadius: '50%',
            height: pxToRem(16),
            minWidth: pxToRem(16),
            right: pxToRem(2),
        },
    },
    rightPaneInnerContainer: {
        height: '100%',
        width: '100%',
        background: '#EDF0F6',
    },
    keynoteText: {
        textAlign: 'center',
    },
    spacer: {
        flexGrow: 1,
    },
    askDelaButton: {
        bottom: '12px',
    },
    trackChangesPanel: {
        transition:
            'width 0.1s cubic-bezier(0.4, 0, 1, 1), opacity 0.3s ease-in-out',
    },
    trackChangesPanelExpanded: {
        width: '38rem',
        minWidth: '38rem',
    },
    trackChangesPanelCollapsed: {
        width: '5.3rem',
        minWidth: '5.3rem',
    },
    specIntPanelExpanded: {
        width: '45.6rem',
        minWidth: '45.6rem',
    },
    '@keyframes specIntPulse': {
        '0%': { transform: 'scale(1)' },
        '50%': { transform: 'scale(1.2)' },
        '100%': { transform: 'scale(1)' },
    },
    specIntBuilding: {
        animation: '$specIntPulse 1.4s ease-in-out infinite',
    },
}))

export default useRightMostPaneStyles
